import React from "react";

const LoadingSpinner = ({
  size = "lg",
  text = "Processing Excel files...",
}) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-4">
      <div
        className={`animate-spin rounded-full border-2 border-gray-300 border-t-primary-600 ${sizeClasses[size]}`}
      ></div>
      {text && (
        <p className="text-sm text-gray-600 text-center max-w-md">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
